import React, { use } from "react";
import { useIntl } from "react-intl";

interface CompareNavigationProps {
	onPrevious: () => void;
	onNext: () => void;
	onAdopt: () => void;
	onCancel: () => void;
	disablePrevious?: boolean;
	disableNext?: boolean;
}

const CompareNavigation: React.FC<CompareNavigationProps> = ({
	onPrevious,
	onNext,
	onAdopt,
	onCancel,
	disablePrevious = false,
	disableNext = false,
}) => {
	const intl = useIntl();

	return (
		<div className="d-flex justify-content-between mb-3 pb-2">
			{/* Left buttons: Cancel & Adopt */}
			<div className="d-flex gap-2">
				<button className="btn btn-light" onClick={onCancel}>
					<i className="fa-solid fa-arrow-left me-2"></i>
					{intl.formatMessage({ id: "cancel" })}
				</button>
				<button className="btn btn-success" onClick={onAdopt}>
					<i className="fa-solid fa-equals me-2"></i>
					{intl.formatMessage({ id: "adopt" })}
				</button>
			</div>

			{/* Right buttons: Previous & Next */}
			<div className="d-flex gap-2">
				<button className="btn btn-danger" onClick={onPrevious} disabled={disablePrevious}>
					<i className="fa-solid fa-chevron-left me-2"></i>
					{intl.formatMessage({ id: "previous" })}
				</button>
				<button className="btn btn-danger" onClick={onNext} disabled={disableNext}>
					{intl.formatMessage({ id: "next" })}
					<i className="fa-solid fa-chevron-right ms-2"></i>
				</button>
			</div>
		</div>
	);
};

export default CompareNavigation;
